import dayjs from 'dayjs';
const formatFullDate = (date) => dayjs(date).format('MMM D [at] hh:mm a z');
export const getDescriptionText = (isMessageBased, description, startTime) => {
    if (isMessageBased) {
        return 'Message-based consult';
    }
    else if (description) {
        return description;
    }
    else if (startTime) {
        return formatFullDate(startTime);
    }
    return '';
};
